import {Device, DeviceType} from "@/components/portfolio/PortfolioProject";

export class DeviceViewModel {
    private device: Device;

    constructor(device: Device) {
        this.device = device;
    }

    getType(): DeviceType {
        return this.device.getType()
    }

    getModifier(): string {
        switch (this.device.getType()) {
            case DeviceType.DESKTOP:
                return 'desktop';
            case DeviceType.TABLET:
                return 'tablet';
            case DeviceType.SMARTPHONE:
                return 'phone';
        }

        return "";
    }

    getStyle(): object {
        return {
            backgroundImage: `url(${this.getPath(this.device.getUrl())})`,
        }
    }

    getUrl(): string {
        return this.getPath(this.device.getUrl());
    }

    private getPath(relPath: string): string {
        if (relPath.length > 0) {
            return require(`./${relPath}`);
        }
        return '';
    }
}